// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_I4YSk","avatar":"index_avatar_13N6B"};